import { graphql } from '../gql'
import { useMutation, useQuery } from 'urql'

export const getUsersQuery = graphql(`
  query Users {
    getUsers {
      users {
        id
        email
        firstName
        lastName
        isVerified
        role
        deactivatedAt
      }
    }
  }
`)

export const useGetUsersQuery = () => useQuery({ query: getUsersQuery })

const inviteUsersMutation = graphql(`
  mutation InviteUsers($invitedUsers: InviteUsersDto!) {
    inviteUsers(invitedUsers: $invitedUsers) {
      users {
        id
        email
        firstName
        lastName
        isVerified
      }
    }
  }
`)
export const useInviteUsersMutation = () => useMutation(inviteUsersMutation)

const deactivateUsersMutation = graphql(`
  mutation DeactivateUser($userId: String!) {
    deactivateUser(userId: $userId) {
      user {
        id
        email
        firstName
        lastName
        isVerified
        role
        deactivatedAt
      }
    }
  }
`)

export const useDeactivateUsersMutation = () => useMutation(deactivateUsersMutation)
